// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JGMnt","newExpiryDate":"styles_newExpiryDate__3sJxe","footer":"styles_footer__1ohq7"};